<div id="showConfirmationDialog" uk-modal #modal>
  <div class="uk-modal-dialog">
    <button class="uk-modal-close-default" type="button" uk-close></button>
    <div class="uk-modal-body">
      <h2 class="uk-text-center" i18n="@@Warning">Warning</h2>
      <div class="uk-modal-body uk-text-center">
        <ng-container i18n="@@aboutToChange">You are about to change</ng-container> {{ numberOfSelectedItems }}
        <ng-container>{{ item }}</ng-container>
        <ng-container i18n="@@multiSuffix">(s)</ng-container>
        <br />
        <ng-container i18n="@@toHave">to have</ng-container> {{ property }}
        <select #select class="uk-select uk-form-small uk-form-width-small">
          <option *ngFor="let variant of variants">{{ variant }}</option>
        </select>
      </div>
    </div>

    <div class="uk-modal-footer uk-text-right">
      <button class="uk-button uk-button-default uk-modal-close uk-margin-small-right" type="button" i18n="@@cancel">cancel</button>
      <button (click)="modalHandler(select.value)" class="uk-button uk-button-primary confirm-button" type="button" i18n="@@Confirm">
        Confirm
      </button>
    </div>
  </div>
</div>
